import sdl from '@jds/react-generated-sdl/JDSFileUploader';
import type { JDSFileUploaderProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFileUploaderProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'undefined',
    expanded = false,
    showDivider = true,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, expanded, showDivider, ...rest },
    'JDSFileUploader',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FileUploader = withLogic(Component) as React.FC<JDSFileUploaderProps> & {
  slotName?: string;
};

FileUploader.displayName = 'FileUploader';
FileUploader.slotName = 'jds_file_uploader';

export { FileUploader, type JDSFileUploaderProps };
